import { Drawer } from 'antd'
import Select from 'react-select'
import React, { useState } from 'react'

import { usePet, useToggle, isValidJson } from '../../modules'

import Confirm from '../reusable/confirm'
import DateRangePicker from '../reusable/rangePicker'

const Input = ({ param, value, setValues }) => {
    const [options, setOptions] = useState((param?.type === 'Select' || param?.type === 'Multi Select') ? param?.source === 'List' ? param?.options?.map(op => ({ label: op, value: op })) : [] : [])
    const [str, setStr] = useState('')
    const [val, setVal] = useState()

    const endPointActive = (param?.type === 'Select' || param?.type === 'Multi Select') && param?.source !== 'List'

    const [{ loading }, execute] = usePet(param?.endpoint, {
        string: str,
        ... isValidJson(param?.payload) ?  JSON.parse(param?.payload) : {}
    }, { notify: true, manual: !endPointActive, callback: ({ data }) => {
        if (param?.labelProperty !== '' && param?.valueProperty) {
            setOptions(data?.map(op => ({ label: op[param?.labelProperty], value: op[param?.valueProperty] })))
        } else {
            setOptions(data?.map(op => ({ label: op, value: op })))
        }
    } })

    console.log({ endPointActive })
    const search = str => {
        setStr(str)

        if (endPointActive)
            execute()
    }

    const onChange = vl => {
        setVal(vl)
        setValues(vals => {
            vals[param?.name] = vl

            return vals
        })
    }

    return (                       
        <div className="w-full px-3 mb-3">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                { param?.name }
            </label>
            {
                param?.type === 'Text' ?
                    <input 
                        onChange={ e => onChange(e.target.value) }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                        id={ `grid-${ param?.name }` }
                        type="text" 
                        value={ val }
                        name={ param?.name }
                        placeholder={ param?.name } />
                : param?.type === 'Number' ?
                    <input 
                        onChange={ e => onChange(e.target.value) }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                        id={ `grid-${ param?.name }` }
                        type="number" 
                        value={ val }
                        name={ param?.name }
                        placeholder={ param?.name } />
                : param?.type === 'Date' ?
                    <DateRangePicker
                        ranges={ val }
                        selectRange={ onChange } />                    
                : param?.type === 'Date Range' ?
                    <DateRangePicker
                        ranges={ val }
                        selectRange={ onChange } />
                : param?.source === 'List' ?
                    <Select
                        value={ val }
                        options={ options }
                        onChange={ onChange }
                        placeholder={ param?.name }
                        isMulti={ param?.type === 'Multi Select' }
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }} />
                :
                    <Select
                        value={ val }
                        options={ options }
                        isLoading={ loading }
                        onChange={ onChange }
                        onInputChange={ search }
                        placeholder={ param?.name }
                        isMulti={ param?.type === 'Multi Select' }
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }} />
            }
        </div> 
    )
}

const NewReport = ({ toggle, visible, reports, onPerform, additional = {} }) => {
    const [title, setTitle] = useState()
    const [ranges, setRanges] = useState()
    const [report, setReport] = useState()
    const [format, setFormat] = useState()
    const [payload, setPayload] = useState({})
    
    const [params, toggleParams] = useToggle()

    const close = () => {
        toggle()
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Report has been received. Please wait for the process to be completed.', ops('success'))
        
        setTimeout(close, 300)
    }
    
    const [{ loading }, execute] = usePet(report?.endpoint, {
        title,
        from: (ranges ?? [])[0]?._d ?? null, 
        to: (ranges ?? [])[1]?._d ?? null,
        template: report?.value,
        format: format?.value,
        ...additional,
        ...payload,
    }, { notify: true, callback: onComplete, manual: true })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={ () => Confirm({
                        title: 'Generate Report',
                        message: 'Your account will be associated with this record. Would you like to proceed?',
                        onOk: execute,
                        okText: 'Proceed',
                    }) } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Generate Report</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">New Report</p>
            <div>
                <div className="flex flex-wrap mt-3 -mx-3">                
                    <div className="w-full px-3 mb-3">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Report
                        </label>
                        <Select
                            value={ report }
                            onChange={ vl => {
                                setReport(vl)
                                setTitle()
                                setFormat()
                                setPayload({})
                            } }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ reports?.map(report => ({ label: report.name, value: report._id, ...report }))  }
                            placeholder="Select Report" />
                    </div>               
                    <div className="w-full px-3 mb-3">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Date Range
                        </label>
                        <DateRangePicker
                            ranges={ ranges }
                            selectRange={ setRanges } />
                    </div>
                    {
                        report &&              
                        <div className="w-full px-3 mb-3">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Report Format
                            </label>
                            <Select
                                value={ format }
                                onChange={ setFormat }
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ report?.outputTypes?.map(format => ({ label: format, value: format }))  }
                                placeholder="Select Format" />
                        </div>  
                    }
                    {
                        report?.parameters?.map((param, i) => 
                            <Input param={ param } value={ payload[param.name] } setValues={ setPayload } />
                        )
                    }
                </div>
            </div>
        </Drawer>
    )
}

export default NewReport